import './checkout_form_step.css';
import { EditIcon } from "../../assets/icons/EditIcon";
import { useCheckout } from "../../context/CheckoutContext";

export const CheckoutFormStep = ({icon, title, step, ...props}) => {
    //HOOKS
    const {checkoutStep, setCheckoutStep, checkoutLoading} = useCheckout();

    return (
        <div className={checkoutStep === step ? 'checkout_form_step active' : 'checkout_form_step'} {...props}>
            <div className='title_container'>
                <span className='icon_container'>
                    {icon}
                </span>
                <h2>
                    {title}
                </h2>
                
                <div className='step_edit_container'>
                    <button onClick={() => setCheckoutStep(step)} disabled={checkoutLoading}>
                        <EditIcon />
                        Edit
                    </button>
                </div>
            </div>
            <div className='content'>
                {
                    props.children
                }
            </div>
            <div className='divider'>

            </div>
        </div>
    );
}